/**
 * 리뷰 상세 URL용 쿼리 생성 (상품 미리보기·PDP·리뷰 목록 등 공통)
 */

export interface GetReviewDetailQueryStringOptions {
  catalogProductId?: string;
  isReplyScroll?: boolean | string;
  /** true면 쿼리에 from=product_preview 포함 (기본: true, 상품 미리보기용) */
  fromProductPreview?: boolean;
}

/** 웹 path용 쿼리 스트링 (leading '?' 없음) */
export function getReviewDetailQueryString(options: GetReviewDetailQueryStringOptions): string {
  const { catalogProductId, isReplyScroll, fromProductPreview = true } = options;
  const hasReplyScroll = Boolean(isReplyScroll);
  return [
    hasReplyScroll && 'scroll_to_reply=true',
    catalogProductId && `product_id=${catalogProductId}`,
    fromProductPreview && 'from=product_preview',
  ]
    .filter(Boolean)
    .join('&');
}

export interface GetReviewDetailQueryParamsForAppOptions {
  reviewId: string;
  catalogProductId?: string;
  isReplyScroll?: boolean | string;
  /** true면 block_product_browsing: true 포함 (기본: true, 앱 웹뷰용) */
  blockProductBrowsing?: boolean;
}

/** 앱 딥링크용 쿼리 객체 (toQueryString에 넘길 값) */
export function getReviewDetailQueryParamsForApp(
  options: GetReviewDetailQueryParamsForAppOptions,
): Record<string, string | boolean> {
  const { reviewId, catalogProductId, isReplyScroll, blockProductBrowsing = true } = options;
  const hasReplyScroll = Boolean(isReplyScroll);
  return {
    review_id: reviewId,
    ...(catalogProductId && { product_id: catalogProductId }),
    ...(blockProductBrowsing && { block_product_browsing: true }),
    ...(hasReplyScroll && { scroll_to_reply: true }),
  };
}
